import { LayoutDashboard, Package, ReceiptText, Settings, Shield, Users } from "lucide-react";
import { Link, Outlet } from "react-router-dom";

const links = [
  ["Dashboard", "/admin", LayoutDashboard],
  ["Products", "/admin/products", Package],
  ["Orders", "/admin/orders", ReceiptText],
  ["Customers", "/admin/customers", Users],
  ["Payments", "/admin/payment-methods", ReceiptText],
  ["Settings", "/admin/settings", Settings],
  ["Roles", "/admin/roles", Shield]
] as const;

export default function AdminLayout() {
  return (
    <div className="min-h-screen bg-slate-100 md:grid md:grid-cols-[260px_1fr]">
      <aside className="border-r bg-white p-4">
        <Link to="/admin" className="mb-6 block"><img src="/logo.svg" className="h-9" /></Link>
        <nav className="space-y-1">{links.map(([label, to, Icon]) => <Link key={to} className="admin-link" to={to}><Icon className="mr-2" size={18} />{label}</Link>)}</nav>
      </aside>
      <main>
        <header className="flex h-16 items-center justify-between border-b bg-white px-6"><span className="font-bold">Admin Console</span><span className="text-sm text-slate-500">Super Admin</span></header>
        <div className="p-4 md:p-6"><Outlet /></div>
      </main>
    </div>
  );
}
